import { render } from "./Navbar.vue?vue&type=template&id=464f2de1"
const script = {}

import "./Navbar.vue?vue&type=style&index=0&id=464f2de1&lang=scss"

import exportComponent from "G:\\Project\\vue_demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__